const inputFilter = {
    mounted(el) {
      const input = el.querySelector('input') || el.querySelector('textarea')
      if (!input) return
  
      input.addEventListener('input', function(e) {
        const start = this.selectionStart
        const end = this.selectionEnd
        const oldValue = this.value
        const newValue = oldValue.replace(/[\\\/:*?"<>|+]/g, '')
        // console.log('oldValue:',oldValue,'newValue:',newValue)
        if (newValue !== oldValue) {
          this.value = newValue
          this.dispatchEvent(new Event('input'))
          this.setSelectionRange(Math.max(0, start - 1), Math.max(0, end - 1))
        }
      })
    }
  }
  
  export default inputFilter